export const QUERY_KEYS = {
  CHURCHES: 'churches',
  CHURCH: 'church',
  CHURCH_ADMINS: 'church-admins',
  CHURCH_ADMIN_ACCESS: 'church-admin-access',
  CHURCH_GROUP_LIST_ADMINS: 'church-group-list-admins',
  CHURCH_ADMIN_SEARCH: 'church-admin-search',
  DIOCESES: 'dioceses',
  CLUSTERS: 'clusters',
  SUPER_ADMINS: 'super-admins',
  KEYWORDS: 'keywords',
  BACKGROUNDS: 'backgrounds',
  MESSAGE_TEMPLATES: 'message-templates',
  MESSAGE_TEMPLATE_TAGS: 'message-template-tags',
  MESSAGE_TEMPLATE_BY_ID: 'message-template-by-id',
  FORM_TEMPLATES: 'form-templates',
  FORM_TEMPLATE_TAGS: 'form-template-tags',
  FORM_TEMPLATE_BY_ID: 'form-template-by-id',
  SUGGESTED_MODULES: 'suggested-modules',
  FORM: 'form',
  MY_PARISH: 'my-parish',
  CAMINO: 'camino',
  CAMINO_MEMBER_IMPORTS: 'camino-member-imports',
  MESSAGING: 'messaging',
  MINISTRY_SCHEDULER: 'ministry-scheduler',
  DIRECT_MESSAGES_REPORTS: 'direct-messages-reports',
  EVA_SYNC_RUNS: 'eva-sync-runs',
  TAB_STATUS: 'tab-status',
} as const;
